export default {
  namespaced: true,

  // initial state
  state: {
    error: null
  },

  //mutations
  mutations: {
    setError(state, error) {
      state.error = error;
    }
  },

  //actions
  actions: {
    setError({ commit }, error) {
      commit("setError", error);
    }
  }
};
